import { mapState, mapActions } from "vuex";

export default {
    computed: {
        ...mapState('User',   ['config_', 'isConfigLoad']),
    },
    methods: {
        ...mapActions("User", ["getConfig", "setConfig"]),
        async loadConfig(force){
            if(force || !this.isConfigLoad)
                await this.setConfig();
        },
        _config(config, dflt){
            var config_ = this.getDescendantVal(config, this.config_);
            return config_ ? config_ : dflt;
        },
    }
}
